export const NumericChart = {
	TABLE: 'table',
} as const;

export type NumericChartType = (typeof NumericChart)[keyof typeof NumericChart];

export const DEFAULT_NUMERIC_CHART_TYPE = NumericChart.TABLE;

export const NumericChartList: NumericChartType[] = Object.values(NumericChart);
